export default {
    pinTitle: 'Hent PIN-kode',
    pinViewText: 'Se PIN-kode',
    pinIngress: 'Her kan du hente ut PIN-koden til kortene dine',
    pinRevealButtonLabel: 'Trykk for å vise PIN-kode',
    pinHideButtonLabel: 'Skjul PIN-kode',
    pinRevealTitle: 'Din PIN-kode er',
    pinRevealCoundownPre: 'PIN-koden vil skjules automatisk om',
    pinRevealCoundownPost: 'sekunder',
    pinErrorText: 'Beklager! Vi kunne dessverre ikke hente PIN-koden akkurat nå. Vennligst prøv igjen senere.',
    pinViewTitle: 'PIN-kode',
    pinViewCodeLabel: 'PIN-koden din er',

    // Pin change decision form
    pinChangeDecisionFormTitle: 'Ønsker du å bruke PIN-koden som du har på andre kort?',
    pinChangeDecisionFormTitleForNewCard: 'Ønsker du å endre PIN-kode for ditt nye kort? ',
    keepPinRadioOption: 'Behold dagens PIN-kode (anbefalt)',
    changePinRadioOption: 'Endre PIN (ikke anbefalt)',
    orderNewCardSkipPin: 'Nei, gi meg PIN-kode',
    orderNewCardSelectPin: 'Velge PIN-kode selv',
    changePinAttentionMessageText1:
        'Hvis du endrer PIN-kode, vil den bli gjeldende for alle fremtidige debet- og kredittkort fra banken.',
    changePinAttentionMessageText2:
        'Eksisterende kort vil fortsatt ha den gamle PIN-koden inntil kortet blir byttet ut.',
    pinNeedsFourCharsError: 'Ny PIN-kode må ha 4 siffer.',
    pinInvalidError: 'PIN-kode må ikke være enkel å gjette, forsøk en mer tilfeldig kombinasjon.',
    chooseNewPinTitle: 'Velg ny PIN-kode',
    confirmChangePin: 'Endre PIN-kode',
    pinChangeErrorText: 'Noe gikk galt. PIN-kode kan ikke endres nå.',
    pinChangeErrorOrderingNewCardText: 'Noe gikk galt. PIN-kode kan ikke settes nå.',
    pinChangeErrorTryLaterOrderingNewCardText: 'Vennligst prøv på nytt senere.',
    pinChangeErrorClickPreviousText:
        'Vennligst prøv på nytt eller trykk «Forrige» og velg å beholde den gamle PIN-koden din.',
    pinChangeSuccessText: 'PIN-kode er endret',
    confirmationChangedPin: 'Du har valgt å endre PIN-kode.',

    // New text for pin ->
    choosePinTitle: 'velg PIN-kode',
    pinSaveSuccessText: 'PIN-kode er lagret',
};
